export const data = [
  //1
  {
    key: "c8-01",
    title: "임금님 귀는 당나귀 귀",
    grade: "1권",
    cover: require("@data/assets/ido/book1/images/cover.png"),
    background: require("@data/assets/ido/book1/pages/page05.png"),
    mov: {
      ko: "9653ed7429894418e64808d194780cbd",
      cn: "a2196337b97783a71557bc196c4d60b5",
      en: "c49244e4289f02e78b37c96ca91d3994",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/ido/book1/images/A01.png"),
          sound: require("@data/assets/ido/book1/sounds/A01.mp3"),
          word: "耳朵|ěrduo",
        },
        {
          img: require("@data/assets/ido/book1/images/A02.png"),
          sound: require("@data/assets/ido/book1/sounds/A02.mp3"),
          word: "驴|<span style='font-family:sans-serif;'>lǘ</span>",
        },
        {
          img: require("@data/assets/ido/book1/images/A03.png"),
          sound: require("@data/assets/ido/book1/sounds/A03.mp3"),
          word: "笛|dí",
        },
        {
          img: require("@data/assets/ido/book1/images/A04.png"),
          sound: require("@data/assets/ido/book1/sounds/A04.mp3"),
          word: "动听|dòngtīng",
        },
        {
          img: require("@data/assets/ido/book1/images/A05.png"),
          sound: require("@data/assets/ido/book1/sounds/A05.mp3"),
          word: "吹|chuī",
        },
        {
          img: require("@data/assets/ido/book1/images/A06.png"),
          sound: require("@data/assets/ido/book1/sounds/A06.mp3"),
          word: "竖琴|shùqín",
        },
        {
          img: require("@data/assets/ido/book1/images/A07.png"),
          sound: require("@data/assets/ido/book1/sounds/A07.mp3"),
          word: "声音|shēngyīn",
        },
        {
          img: require("@data/assets/ido/book1/images/A08.png"),
          sound: require("@data/assets/ido/book1/sounds/A08.mp3"),
          word: "演奏|yǎnzòu",
        },
        {
          img: require("@data/assets/ido/book1/images/A09.png"),
          sound: require("@data/assets/ido/book1/sounds/A09.mp3"),
          word: "生气|shēngqì",
        },
        {
          img: require("@data/assets/ido/book1/images/A10.png"),
          sound: require("@data/assets/ido/book1/sounds/A10.mp3"),
          word: "变成|biànchéng",
        },
        {
          img: require("@data/assets/ido/book1/images/A11.png"),
          sound: require("@data/assets/ido/book1/sounds/A11.mp3"),
          word: "笑话|xiàohua",
        },
        {
          img: require("@data/assets/ido/book1/images/A12.png"),
          sound: require("@data/assets/ido/book1/sounds/A12.mp3"),
          word: "办法|bànfǎ",
        },
        {
          img: require("@data/assets/ido/book1/images/A13.png"),
          sound: require("@data/assets/ido/book1/sounds/A13.mp3"),
          word: "戴|dài",
        },
        {
          img: require("@data/assets/ido/book1/images/A14.png"),
          sound: require("@data/assets/ido/book1/sounds/A14.mp3"),
          word: "帽子|màozi",
        },
        {
          img: require("@data/assets/ido/book1/images/A15.png"),
          sound: require("@data/assets/ido/book1/sounds/A15.mp3"),
          word: "剪|jiǎn",
        },
        {
          img: require("@data/assets/ido/book1/images/A16.png"),
          sound: require("@data/assets/ido/book1/sounds/A16.mp3"),
          word: "惩罚|chéngfá",
        },
        {
          img: require("@data/assets/ido/book1/images/A17.png"),
          sound: require("@data/assets/ido/book1/sounds/A17.mp3"),
          word: "承诺|chéngnuò",
        },
        {
          img: require("@data/assets/ido/book1/images/A18.png"),
          sound: require("@data/assets/ido/book1/sounds/A18.mp3"),
          word: "痒痒|yǎngyang",
        },
        {
          img: require("@data/assets/ido/book1/images/A19.png"),
          sound: require("@data/assets/ido/book1/sounds/A19.mp3"),
          word: "郁闷|yùmèn",
        },
        {
          img: require("@data/assets/ido/book1/images/A20.png"),
          sound: require("@data/assets/ido/book1/sounds/A20.mp3"),
          word: "周围|zhōuwéi",
        },
        {
          img: require("@data/assets/ido/book1/images/A21.png"),
          sound: require("@data/assets/ido/book1/sounds/A21.mp3"),
          word: "坑|kēng",
        },
        {
          img: require("@data/assets/ido/book1/images/A22.png"),
          sound: require("@data/assets/ido/book1/sounds/A22.mp3"),
          word: "愉快|yúkuài",
        },
        {
          img: require("@data/assets/ido/book1/images/A23.png"),
          sound: require("@data/assets/ido/book1/sounds/A23.mp3"),
          word: "传来|chuánlái",
        },
        {
          img: require("@data/assets/ido/book1/images/A24.png"),
          sound: require("@data/assets/ido/book1/sounds/A24.mp3"),
          word: "奇怪|qíguài",
        },
        {
          img: require("@data/assets/ido/book1/images/A25.png"),
          sound: require("@data/assets/ido/book1/sounds/A25.mp3"),
          word: "原因|yuányīn",
        },
        {
          img: require("@data/assets/ido/book1/images/A26.png"),
          sound: require("@data/assets/ido/book1/sounds/A26.mp3"),
          word: "藏|cáng",
        },
        {
          img: require("@data/assets/ido/book1/images/A27.png"),
          sound: require("@data/assets/ido/book1/sounds/A27.mp3"),
          word: "认真|rènzhēn",
        },
        {
          img: require("@data/assets/ido/book1/images/A28.png"),
          sound: require("@data/assets/ido/book1/sounds/A28.mp3"),
          word: "倾听|qīngtīng",
        },
        {
          img: require("@data/assets/ido/book1/images/A29.png"),
          sound: require("@data/assets/ido/book1/sounds/A29.mp3"),
          word: "受到|shòu dào",
        },
        {
          img: require("@data/assets/ido/book1/images/A30.png"),
          sound: require("@data/assets/ido/book1/sounds/A30.mp3"),
          word: "尊敬|zūnjìng",
        },
      ],
      resources2: [
        {
          img: require("@data/assets/ido/book1/images/q1.png"),
          sound: require("@data/assets/ido/book1/sounds/q1.mp3"),
          word: "音乐之神演奏了竖琴。|",
        },
        {
          img: require("@data/assets/ido/book1/images/q2.png"),
          sound: require("@data/assets/ido/book1/sounds/q2.mp3"),
          word: "国王的耳朵就变得像驴耳朵一样，又尖又长。|",
        },
        {
          img: require("@data/assets/ido/book1/images/q3.png"),
          sound: require("@data/assets/ido/book1/sounds/q3.mp3"),
          word: "国王从来都不取下帽子。|",
        },
        {
          img: require("@data/assets/ido/book1/images/q4.png"),
          sound: require("@data/assets/ido/book1/sounds/q4.mp3"),
          word: "看到国王耳朵的一瞬间， 理发师吓了一大跳。|",
        },
        {
          img: require("@data/assets/ido/book1/images/q5.png"),
          sound: require("@data/assets/ido/book1/sounds/q5.mp3"),
          word: "之后， 国王再也不戴帽子了。|",
        },
      ],
    },
    word: [
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A01.mp3"),
        buttons: [{ ch: "耳朵" }, { ch2: "ěrduo" }, { ko: "귀" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A02.mp3"),
        buttons: [
          { ch: "驴" },
          { ch2: "<span style='font-family:sans-serif;'>lǘ</span>" },
          { ko: "당나귀" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A03.mp3"),
        buttons: [{ ch: "笛" }, { ch2: "dí" }, { ko: "피리" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A04.mp3"),
        buttons: [
          { ch: "动听" },
          { ch2: "dòngtīng" },
          { ko: "듣기 좋다, <br>듣기에 <br>감동적이다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A05.mp3"),
        buttons: [
          { ch: "吹" },
          { ch2: "chuī" },
          { ko: "불다, <br>불어서 <br>연주하다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A06.mp3"),
        buttons: [{ ch: "竖琴" }, { ch2: "shùqín" }, { ko: "하프" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A07.mp3"),
        buttons: [{ ch: "声音" }, { ch2: "shēngyīn" }, { ko: "소리" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A08.mp3"),
        buttons: [{ ch: "演奏" }, { ch2: "yǎnzòu" }, { ko: "연주하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A09.mp3"),
        buttons: [{ ch: "生气" }, { ch2: "shēngqì" }, { ko: "화내다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A10.mp3"),
        buttons: [{ ch: "变成" }, { ch2: "biànchéng" }, { ko: "~로 변하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A11.mp3"),
        buttons: [{ ch: "笑话" }, { ch2: "xiàohua" }, { ko: "비웃다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A12.mp3"),
        buttons: [{ ch: "办法" }, { ch2: "bànfǎ" }, { ko: "방법, 수단" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A13.mp3"),
        buttons: [{ ch: "戴" }, { ch2: "dài" }, { ko: "착용하다, 쓰다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A14.mp3"),
        buttons: [{ ch: "帽子" }, { ch2: "màozi" }, { ko: "모자" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A15.mp3"),
        buttons: [{ ch: "剪" }, { ch2: "jiǎn" }, { ko: "자르다, 깎다" }],
      },
    ],
    idiom: [
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A16.mp3"),
        buttons: [{ ch: "惩罚" }, { ch2: "chéngfá" }, { ko: "징벌하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A17.mp3"),
        buttons: [{ ch: "承诺" }, { ch2: "chéngnuò" }, { ko: "승낙, 대답" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A18.mp3"),
        buttons: [
          { ch: "痒痒" },
          { ch2: "yǎngyang" },
          { ko: "근질근질하다, 가렵다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A19.mp3"),
        buttons: [{ ch: "郁闷" }, { ch2: "yùmèn" }, { ko: "우울하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A20.mp3"),
        buttons: [{ ch: "周围" }, { ch2: "zhōuwéi" }, { ko: "주위, 주변" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A21.mp3"),
        buttons: [{ ch: "坑" }, { ch2: "kēng" }, { ko: "땅굴" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A22.mp3"),
        buttons: [{ ch: "愉快" }, { ch2: "yúkuài" }, { ko: "기쁘다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A23.mp3"),
        buttons: [
          { ch: "传来" },
          { ch2: "chuánlái" },
          { ko: "전해 내려오다, 들려오다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A24.mp3"),
        buttons: [
          { ch: "奇怪" },
          { ch2: "qíguài" },
          { ko: "기이하다, <br>신기하다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A25.mp3"),
        buttons: [{ ch: "原因" }, { ch2: "yuányīn" }, { ko: "원인" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A26.mp3"),
        buttons: [{ ch: "藏" }, { ch2: "cáng" }, { ko: "숨기다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A27.mp3"),
        buttons: [{ ch: "认真" }, { ch2: "rènzhēn" }, { ko: "진지하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A28.mp3"),
        buttons: [
          { ch: "倾听" },
          { ch2: "qīngtīng" },
          { ko: "경청하다, <br>귀를 기울여 <br>듣다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A29.mp3"),
        buttons: [{ ch: "受到" }, { ch2: "shòu dào" }, { ko: "받다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book1/sounds/A30.mp3"),
        buttons: [
          { ch: "尊敬" },
          { ch2: "zūnjìng" },
          { ko: "존경하다, <br>존경받다" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/ido/book1/sounds/q1.mp3"),
          img: require("@data/assets/ido/book1/images/q1.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty3",
          sound: require("@data/assets/ido/book1/sounds/A14.mp3"),
          answer: [
            ["帽子", true],
            ["耳朵", false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/ido/book1/sounds/A10.mp3"),
          answer: [
            ["生气", false],
            ["变成", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/ido/book1/pages/front.png"),
        sound: require("@data/assets/ido/book1/sounds/cover.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page02.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page03.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page04.png"),
        sound: require("@data/assets/ido/book1/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page05.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page06.png"),
        sound: require("@data/assets/ido/book1/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page07.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page08.png"),
        sound: require("@data/assets/ido/book1/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page09.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page10.png"),
        sound: require("@data/assets/ido/book1/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page11.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page12.png"),
        sound: require("@data/assets/ido/book1/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page13.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page14.png"),
        sound: require("@data/assets/ido/book1/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page15.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page16.png"),
        sound: require("@data/assets/ido/book1/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page17.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page18.png"),
        sound: require("@data/assets/ido/book1/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page19.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page20.png"),
        sound: require("@data/assets/ido/book1/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page21.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page22.png"),
        sound: require("@data/assets/ido/book1/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page23.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page24.png"),
        sound: require("@data/assets/ido/book1/sounds/page24.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page25.png"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page26.png"),
        sound: require("@data/assets/ido/book1/sounds/page26.mp3"),
      },
      {
        book: require("@data/assets/ido/book1/pages/page27.png"),
      },
    ],
    thumbnail: [
      require("@data/assets/ido/book1/thumbnail/front.png"),
      require("@data/assets/ido/book1/thumbnail/page04.png"),
      require("@data/assets/ido/book1/thumbnail/page05.png"),
      require("@data/assets/ido/book1/thumbnail/page06.png"),
      require("@data/assets/ido/book1/thumbnail/page07.png"),
      require("@data/assets/ido/book1/thumbnail/page08.png"),
      require("@data/assets/ido/book1/thumbnail/page09.png"),
      require("@data/assets/ido/book1/thumbnail/page10.png"),
      require("@data/assets/ido/book1/thumbnail/page11.png"),
      require("@data/assets/ido/book1/thumbnail/page12.png"),
      require("@data/assets/ido/book1/thumbnail/page13.png"),
      require("@data/assets/ido/book1/thumbnail/page14.png"),
      require("@data/assets/ido/book1/thumbnail/page15.png"),
      require("@data/assets/ido/book1/thumbnail/page16.png"),
      require("@data/assets/ido/book1/thumbnail/page17.png"),
      require("@data/assets/ido/book1/thumbnail/page18.png"),
      require("@data/assets/ido/book1/thumbnail/page19.png"),
      require("@data/assets/ido/book1/thumbnail/page20.png"),
      require("@data/assets/ido/book1/thumbnail/page21.png"),
      require("@data/assets/ido/book1/thumbnail/page22.png"),
      require("@data/assets/ido/book1/thumbnail/page23.png"),
      require("@data/assets/ido/book1/thumbnail/page24.png"),
      require("@data/assets/ido/book1/thumbnail/page25.png"),
      require("@data/assets/ido/book1/thumbnail/page26.png"),
      require("@data/assets/ido/book1/thumbnail/page27.png"),
    ],
  },
  //2
  {
    key: "c8-02",
    title: "사자와 생쥐",
    grade: "2권",
    cover: require("@data/assets/ido/book2/images/cover.png"),
    background: require("@data/assets/ido/book2/pages/page05.png"),
    mov: {
      ko: "a70dac9dce2fdcb8067fc4dcef368b0e",
      cn: "bc2c5a77e945ab506cf27f7d83349e53",
      en: "f3c678e03a1745faec1634a6377f9cc4",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/ido/book2/images/B01.png"),
          sound: require("@data/assets/ido/book2/sounds/B01.mp3"),
          word: "狮子|shīzi",
        },
        {
          img: require("@data/assets/ido/book2/images/B02.png"),
          sound: require("@data/assets/ido/book2/sounds/B02.mp3"),
          word: "老鼠|lǎoshǔ",
        },
        {
          img: require("@data/assets/ido/book2/images/B03.png"),
          sound: require("@data/assets/ido/book2/sounds/B03.mp3"),
          word: "暖洋洋|nuǎnyángyáng",
        },
        {
          img: require("@data/assets/ido/book2/images/B04.png"),
          sound: require("@data/assets/ido/book2/sounds/B04.mp3"),
          word: "睡午觉|shuì wǔjiào",
        },
        {
          img: require("@data/assets/ido/book2/images/B05.png"),
          sound: require("@data/assets/ido/book2/sounds/B05.mp3"),
          word: "适合|shìhé",
        },
        {
          img: require("@data/assets/ido/book2/images/B06.png"),
          sound: require("@data/assets/ido/book2/sounds/B06.mp3"),
          word: "好像|hǎoxiàng",
        },
        {
          img: require("@data/assets/ido/book2/images/B07.png"),
          sound: require("@data/assets/ido/book2/sounds/B07.mp3"),
          word: "尾巴|wěiba",
        },
        {
          img: require("@data/assets/ido/book2/images/B08.png"),
          sound: require("@data/assets/ido/book2/sounds/B08.mp3"),
          word: "爪子|zhuǎzi",
        },
        {
          img: require("@data/assets/ido/book2/images/B09.png"),
          sound: require("@data/assets/ido/book2/sounds/B09.mp3"),
          word: "抓|zhuā",
        },
        {
          img: require("@data/assets/ido/book2/images/B10.png"),
          sound: require("@data/assets/ido/book2/sounds/B10.mp3"),
          word: "背|bèi",
        },
        {
          img: require("@data/assets/ido/book2/images/B11.png"),
          sound: require("@data/assets/ido/book2/sounds/B11.mp3"),
          word: "搅|jiǎo",
        },
        {
          img: require("@data/assets/ido/book2/images/B12.png"),
          sound: require("@data/assets/ido/book2/sounds/B12.mp3"),
          word: "美梦|měimèng",
        },
        {
          img: require("@data/assets/ido/book2/images/B13.png"),
          sound: require("@data/assets/ido/book2/sounds/B13.mp3"),
          word: "要是|yàoshi",
        },
        {
          img: require("@data/assets/ido/book2/images/B14.png"),
          sound: require("@data/assets/ido/book2/sounds/B14.mp3"),
          word: "放|fàng",
        },
        {
          img: require("@data/assets/ido/book2/images/B15.png"),
          sound: require("@data/assets/ido/book2/sounds/B15.mp3"),
          word: "报恩|bào'ēn",
        },
        {
          img: require("@data/assets/ido/book2/images/B16.png"),
          sound: require("@data/assets/ido/book2/sounds/B16.mp3"),
          word: "捕猎|bǔliè",
        },
        {
          img: require("@data/assets/ido/book2/images/B17.png"),
          sound: require("@data/assets/ido/book2/sounds/B17.mp3"),
          word: "陷阱|xiànjǐng",
        },
        {
          img: require("@data/assets/ido/book2/images/B18.png"),
          sound: require("@data/assets/ido/book2/sounds/B18.mp3"),
          word: "突然|tūrán",
        },
        {
          img: require("@data/assets/ido/book2/images/B19.png"),
          sound: require("@data/assets/ido/book2/sounds/B19.mp3"),
          word: "流|liú",
        },
        {
          img: require("@data/assets/ido/book2/images/B20.png"),
          sound: require("@data/assets/ido/book2/sounds/B20.mp3"),
          word: "眼泪|yǎnlèi",
        },
        {
          img: require("@data/assets/ido/book2/images/B21.png"),
          sound: require("@data/assets/ido/book2/sounds/B21.mp3"),
          word: "喊|hǎn",
        },
        {
          img: require("@data/assets/ido/book2/images/B22.png"),
          sound: require("@data/assets/ido/book2/sounds/B22.mp3"),
          word: "开始|kāishǐ",
        },
        {
          img: require("@data/assets/ido/book2/images/B23.png"),
          sound: require("@data/assets/ido/book2/sounds/B23.mp3"),
          word: "牙齿|yáchǐ",
        },
        {
          img: require("@data/assets/ido/book2/images/B24.png"),
          sound: require("@data/assets/ido/book2/sounds/B24.mp3"),
          word: "啃|kěn",
        },
        {
          img: require("@data/assets/ido/book2/images/B25.png"),
          sound: require("@data/assets/ido/book2/sounds/B25.mp3"),
          word: "网|wǎng",
        },
        {
          img: require("@data/assets/ido/book2/images/B26.png"),
          sound: require("@data/assets/ido/book2/sounds/B26.mp3"),
          word: "获得|huòdé",
        },
        {
          img: require("@data/assets/ido/book2/images/B27.png"),
          sound: require("@data/assets/ido/book2/sounds/B27.mp3"),
          word: "忘记|wàngjì",
        },
        {
          img: require("@data/assets/ido/book2/images/B28.png"),
          sound: require("@data/assets/ido/book2/sounds/B28.mp3"),
          word: "诺言|nuòyán",
        },
        {
          img: require("@data/assets/ido/book2/images/B29.png"),
          sound: require("@data/assets/ido/book2/sounds/B29.mp3"),
          word: "遵守|zūnshǒu",
        },
        {
          img: require("@data/assets/ido/book2/images/B30.png"),
          sound: require("@data/assets/ido/book2/sounds/B30.mp3"),
          word: "摆|bǎi",
        },
      ],
      resources2: [
        {
          img: require("@data/assets/ido/book2/images/q1.png"),
          sound: require("@data/assets/ido/book2/sounds/q1.mp3"),
          word: "一只小老鼠骨碌碌地跑了过来。|",
        },
        {
          img: require("@data/assets/ido/book2/images/q2.png"),
          sound: require("@data/assets/ido/book2/sounds/q2.mp3"),
          word: "“抓到了！你这个小老鼠！”|",
        },
        {
          img: require("@data/assets/ido/book2/images/q3.png"),
          sound: require("@data/assets/ido/book2/sounds/q3.mp3"),
          word: "狮子嘿嘿一笑，放开了小老鼠。|",
        },
        {
          img: require("@data/assets/ido/book2/images/q4.png"),
          sound: require("@data/assets/ido/book2/sounds/q4.mp3"),
          word: "狮子慢慢悠悠地在森林里走来走去，突然发现了一块肉。|",
        },
        {
          img: require("@data/assets/ido/book2/images/q5.png"),
          sound: require("@data/assets/ido/book2/sounds/q5.mp3"),
          word: "小老鼠开始用白白的牙齿啃网。|",
        },
        {
          img: require("@data/assets/ido/book2/images/q6.png"),
          sound: require("@data/assets/ido/book2/sounds/q6.mp3"),
          word: "狮子终于获得了自由。|",
        },
      ],
    },
    word: [
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B01.mp3"),
        buttons: [{ ch: "狮子" }, { ch2: "shīzi" }, { ko: "사자" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B02.mp3"),
        buttons: [{ ch: "老鼠" }, { ch2: "lǎoshǔ" }, { ko: "쥐" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B03.mp3"),
        buttons: [
          { ch: "暖洋洋" },
          { ch2: "nuǎnyángyáng" },
          { ko: "따사롭다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B04.mp3"),
        buttons: [
          { ch: "睡午觉" },
          { ch2: "shuì wǔjiào" },
          { ko: "낮잠을 자다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B05.mp3"),
        buttons: [{ ch: "适合" }, { ch2: "shìhé" }, { ko: "적합하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B06.mp3"),
        buttons: [{ ch: "好像" }, { ch2: "hǎoxiàng" }, { ko: "마치 ~와 같다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B07.mp3"),
        buttons: [{ ch: "尾巴" }, { ch2: "wěiba" }, { ko: "꼬리" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B08.mp3"),
        buttons: [{ ch: "爪子" }, { ch2: "zhuǎzi" }, { ko: "발톱" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B09.mp3"),
        buttons: [{ ch: "抓" }, { ch2: "zhuā" }, { ko: "쥐다, 잡다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B10.mp3"),
        buttons: [{ ch: "背" }, { ch2: "bèi" }, { ko: "등" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B11.mp3"),
        buttons: [
          { ch: "搅" },
          { ch2: "jiǎo" },
          { ko: "혼란시키다, <br>방해하다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B12.mp3"),
        buttons: [{ ch: "美梦" }, { ch2: "měimèng" }, { ko: "단꿈" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B13.mp3"),
        buttons: [{ ch: "要是" }, { ch2: "yàoshi" }, { ko: "만약 ~라면" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B14.mp3"),
        buttons: [
          { ch: "放" },
          { ch2: "fàng" },
          { ko: "놓아주다, <br>풀어주다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B15.mp3"),
        buttons: [{ ch: "报恩" }, { ch2: "bào'ēn" }, { ko: "은혜를 갚다" }],
      },
    ],
    idiom: [
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B16.mp3"),
        buttons: [{ ch: "捕猎" }, { ch2: "bǔliè" }, { ko: "사냥하다, 잡다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B17.mp3"),
        buttons: [{ ch: "陷阱" }, { ch2: "xiànjǐng" }, { ko: "함정" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B18.mp3"),
        buttons: [{ ch: "突然" }, { ch2: "tūrán" }, { ko: "갑자기" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B19.mp3"),
        buttons: [{ ch: "流" }, { ch2: "liú" }, { ko: "흐르다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B20.mp3"),
        buttons: [{ ch: "眼泪" }, { ch2: "yǎnlèi" }, { ko: "눈물" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B21.mp3"),
        buttons: [{ ch: "喊" }, { ch2: "hǎn" }, { ko: "외치다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B22.mp3"),
        buttons: [{ ch: "开始" }, { ch2: "kāishǐ" }, { ko: "시작하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B23.mp3"),
        buttons: [{ ch: "牙齿" }, { ch2: "yáchǐ" }, { ko: "이, 치아" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B24.mp3"),
        buttons: [
          { ch: "啃" },
          { ch2: "kěn" },
          { ko: "물어뜯다, <br>갉아먹다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B25.mp3"),
        buttons: [{ ch: "网" }, { ch2: "wǎng" }, { ko: "그물" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B26.mp3"),
        buttons: [{ ch: "获得" }, { ch2: "huòdé" }, { ko: "얻다, 취득하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B27.mp3"),
        buttons: [
          { ch: "忘记" },
          { ch2: "wàngjì" },
          { ko: "잊다, <br>잊어버리다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B28.mp3"),
        buttons: [{ ch: "诺言" }, { ch2: "nuòyán" }, { ko: "약속" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B29.mp3"),
        buttons: [
          { ch: "遵守" },
          { ch2: "zūnshǒu" },
          { ko: "준수하다, <br>지키다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book2/sounds/B30.mp3"),
        buttons: [{ ch: "摆" }, { ch2: "bǎi" }, { ko: "흔들다" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/ido/book2/sounds/q3.mp3"),
          img: require("@data/assets/ido/book2/images/q2.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty3",
          sound: require("@data/assets/ido/book2/sounds/B05.mp3"),
          answer: [
            ["开始", false],
            ["适合", true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/ido/book2/sounds/B23.mp3"),
          answer: [
            ["眼泪", false],
            ["牙齿", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/ido/book2/pages/front.png"),
        sound: require("@data/assets/ido/book2/sounds/cover.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page02.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page03.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page04.png"),
        sound: require("@data/assets/ido/book2/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page05.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page06.png"),
        sound: require("@data/assets/ido/book2/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page07.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page08.png"),
        sound: require("@data/assets/ido/book2/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page09.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page10.png"),
        sound: require("@data/assets/ido/book2/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page11.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page12.png"),
        sound: require("@data/assets/ido/book2/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page13.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page14.png"),
        sound: require("@data/assets/ido/book2/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page15.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page16.png"),
        sound: require("@data/assets/ido/book2/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page17.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page18.png"),
        sound: require("@data/assets/ido/book2/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page19.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page20.png"),
        sound: require("@data/assets/ido/book2/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page21.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page22.png"),
        sound: require("@data/assets/ido/book2/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page23.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page24.png"),
        sound: require("@data/assets/ido/book2/sounds/page24.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page25.png"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page26.png"),
        sound: require("@data/assets/ido/book2/sounds/page26.mp3"),
      },
      {
        book: require("@data/assets/ido/book2/pages/page27.png"),
      },
    ],
    thumbnail: [
      require("@data/assets/ido/book2/thumbnail/front.png"),
      require("@data/assets/ido/book2/thumbnail/page04.png"),
      require("@data/assets/ido/book2/thumbnail/page05.png"),
      require("@data/assets/ido/book2/thumbnail/page06.png"),
      require("@data/assets/ido/book2/thumbnail/page07.png"),
      require("@data/assets/ido/book2/thumbnail/page08.png"),
      require("@data/assets/ido/book2/thumbnail/page09.png"),
      require("@data/assets/ido/book2/thumbnail/page10.png"),
      require("@data/assets/ido/book2/thumbnail/page11.png"),
      require("@data/assets/ido/book2/thumbnail/page12.png"),
      require("@data/assets/ido/book2/thumbnail/page13.png"),
      require("@data/assets/ido/book2/thumbnail/page14.png"),
      require("@data/assets/ido/book2/thumbnail/page15.png"),
      require("@data/assets/ido/book2/thumbnail/page16.png"),
      require("@data/assets/ido/book2/thumbnail/page17.png"),
      require("@data/assets/ido/book2/thumbnail/page18.png"),
      require("@data/assets/ido/book2/thumbnail/page19.png"),
      require("@data/assets/ido/book2/thumbnail/page20.png"),
      require("@data/assets/ido/book2/thumbnail/page21.png"),
      require("@data/assets/ido/book2/thumbnail/page22.png"),
      require("@data/assets/ido/book2/thumbnail/page23.png"),
      require("@data/assets/ido/book2/thumbnail/page24.png"),
      require("@data/assets/ido/book2/thumbnail/page25.png"),
      require("@data/assets/ido/book2/thumbnail/page26.png"),
      require("@data/assets/ido/book2/thumbnail/page27.png"),
    ],
  },
  //3
  {
    key: "c8-03",
    title: "바람과 해님",
    grade: "3권",
    cover: require("@data/assets/ido/book3/images/cover.png"),
    background: require("@data/assets/ido/book3/pages/page05.png"),
    mov: {
      ko: "952cfaf6ed3e02b6fe96aee0aa30b4a4",
      cn: "88c72053c0329de63b9bf9d82ce1b370",
      en: "7d7d50b573ab6331f8f7089d2e502397",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/ido/book3/images/C01.png"),
          sound: require("@data/assets/ido/book3/sounds/C01.mp3"),
          word: "风|fēng",
        },
        {
          img: require("@data/assets/ido/book3/images/C02.png"),
          sound: require("@data/assets/ido/book3/sounds/C02.mp3"),
          word: "太阳|tàiyáng",
        },
        {
          img: require("@data/assets/ido/book3/images/C03.png"),
          sound: require("@data/assets/ido/book3/sounds/C03.mp3"),
          word: "亲密|qīnmì",
        },
        {
          img: require("@data/assets/ido/book3/images/C04.png"),
          sound: require("@data/assets/ido/book3/sounds/C04.mp3"),
          word: "哭|kū",
        },
        {
          img: require("@data/assets/ido/book3/images/C05.png"),
          sound: require("@data/assets/ido/book3/sounds/C05.mp3"),
          word: "追|zhuī",
        },
        {
          img: require("@data/assets/ido/book3/images/C06.png"),
          sound: require("@data/assets/ido/book3/sounds/C06.mp3"),
          word: "伙伴|huǒbàn",
        },
        {
          img: require("@data/assets/ido/book3/images/C07.png"),
          sound: require("@data/assets/ido/book3/sounds/C07.mp3"),
          word: "担心|dānxīn",
        },
        {
          img: require("@data/assets/ido/book3/images/C08.png"),
          sound: require("@data/assets/ido/book3/sounds/C08.mp3"),
          word: "吹|chuī",
        },
        {
          img: require("@data/assets/ido/book3/images/C09.png"),
          sound: require("@data/assets/ido/book3/sounds/C09.mp3"),
          word: "飞|fēi",
        },
        {
          img: require("@data/assets/ido/book3/images/C10.png"),
          sound: require("@data/assets/ido/book3/sounds/C10.mp3"),
          word: "花籽|huāzĭ",
        },
        {
          img: require("@data/assets/ido/book3/images/C11.png"),
          sound: require("@data/assets/ido/book3/sounds/C11.mp3"),
          word: "树叶|shùyè",
        },
        {
          img: require("@data/assets/ido/book3/images/C12.png"),
          sound: require("@data/assets/ido/book3/sounds/C12.mp3"),
          word: "被子|bèizi",
        },
        {
          img: require("@data/assets/ido/book3/images/C13.png"),
          sound: require("@data/assets/ido/book3/sounds/C13.mp3"),
          word: "湿|shī",
        },
        {
          img: require("@data/assets/ido/book3/images/C14.png"),
          sound: require("@data/assets/ido/book3/sounds/C14.mp3"),
          word: "照|zhào",
        },
        {
          img: require("@data/assets/ido/book3/images/C15.png"),
          sound: require("@data/assets/ido/book3/sounds/C15.mp3"),
          word: "变|biàn",
        },
        {
          img: require("@data/assets/ido/book3/images/C16.png"),
          sound: require("@data/assets/ido/book3/sounds/C16.mp3"),
          word: "轻|qīng",
        },
        {
          img: require("@data/assets/ido/book3/images/C17.png"),
          sound: require("@data/assets/ido/book3/sounds/C17.mp3"),
          word: "口哨|kǒushào",
        },
        {
          img: require("@data/assets/ido/book3/images/C18.png"),
          sound: require("@data/assets/ido/book3/sounds/C18.mp3"),
          word: "打招呼|dǎ zhāohu",
        },
        {
          img: require("@data/assets/ido/book3/images/C19.png"),
          sound: require("@data/assets/ido/book3/sounds/C19.mp3"),
          word: "玩|wán",
        },
        {
          img: require("@data/assets/ido/book3/images/C20.png"),
          sound: require("@data/assets/ido/book3/sounds/C20.mp3"),
          word: "行人|xíngrén",
        },
        {
          img: require("@data/assets/ido/book3/images/C21.png"),
          sound: require("@data/assets/ido/book3/sounds/C21.mp3"),
          word: "脱|tuō",
        },
        {
          img: require("@data/assets/ido/book3/images/C22.png"),
          sound: require("@data/assets/ido/book3/sounds/C22.mp3"),
          word: "有意思|yǒu yìsi",
        },
        {
          img: require("@data/assets/ido/book3/images/C23.png"),
          sound: require("@data/assets/ido/book3/sounds/C23.mp3"),
          word: "自信|zìxìn",
        },
        {
          img: require("@data/assets/ido/book3/images/C24.png"),
          sound: require("@data/assets/ido/book3/sounds/C24.mp3"),
          word: "刮|guā",
        },
        {
          img: require("@data/assets/ido/book3/images/C25.png"),
          sound: require("@data/assets/ido/book3/sounds/C25.mp3"),
          word: "冷|lěng",
        },
        {
          img: require("@data/assets/ido/book3/images/C26.png"),
          sound: require("@data/assets/ido/book3/sounds/C26.mp3"),
          word: "围脖|wéibó",
        },
        {
          img: require("@data/assets/ido/book3/images/C27.png"),
          sound: require("@data/assets/ido/book3/sounds/C27.mp3"),
          word: "松开|sōngkāi",
        },
        {
          img: require("@data/assets/ido/book3/images/C28.png"),
          sound: require("@data/assets/ido/book3/sounds/C28.mp3"),
          word: "靠|kào",
        },
        {
          img: require("@data/assets/ido/book3/images/C29.png"),
          sound: require("@data/assets/ido/book3/sounds/C29.mp3"),
          word: "力量|lìliang",
        },
        {
          img: require("@data/assets/ido/book3/images/C30.png"),
          sound: require("@data/assets/ido/book3/sounds/C30.mp3"),
          word: "肩膀|jiānbǎng",
        },
      ],
      resources2: [
        {
          img: require("@data/assets/ido/book3/images/q1.png"),
          sound: require("@data/assets/ido/book3/sounds/q1.mp3"),
          word: "风和太阳隔着广阔的田野上比邻而居。|",
        },
        {
          img: require("@data/assets/ido/book3/images/q2.png"),
          sound: require("@data/assets/ido/book3/sounds/q2.mp3"),
          word: "被子呼哧呼哧地说： “身子湿了， 太重了。”|",
        },
        {
          img: require("@data/assets/ido/book3/images/q3.png"),
          sound: require("@data/assets/ido/book3/sounds/q3.mp3"),
          word: "风和太阳高兴地互相打招呼。|",
        },
        {
          img: require("@data/assets/ido/book3/images/q4.png"),
          sound: require("@data/assets/ido/book3/sounds/q4.mp3"),
          word: "风用尽全力吹出一口气。|",
        },
        {
          img: require("@data/assets/ido/book3/images/q5.png"),
          sound: require("@data/assets/ido/book3/sounds/q5.mp3"),
          word: "太阳光火辣辣地照下来，行人松开了围脖。|",
        },
        {
          img: require("@data/assets/ido/book3/images/q6.png"),
          sound: require("@data/assets/ido/book3/sounds/q6.mp3"),
          word: "行人脱掉了大衣。|",
        },
      ],
    },
    word: [
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C01.mp3"),
        buttons: [{ ch: "风" }, { ch2: "fēng" }, { ko: "바람" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C02.mp3"),
        buttons: [{ ch: "太阳" }, { ch2: "tàiyáng" }, { ko: "태양" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C03.mp3"),
        buttons: [{ ch: "亲密" }, { ch2: "qīnmì" }, { ko: "친밀하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C04.mp3"),
        buttons: [{ ch: "哭" }, { ch2: "kū" }, { ko: "울다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C05.mp3"),
        buttons: [{ ch: "追" }, { ch2: "zhuī" }, { ko: "뒤쫓다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C06.mp3"),
        buttons: [{ ch: "伙伴" }, { ch2: "huǒbàn" }, { ko: "동료, 친구" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C07.mp3"),
        buttons: [
          { ch: "担心" },
          { ch2: "dānxīn" },
          { ko: "염려하다, <br>걱정하다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C08.mp3"),
        buttons: [{ ch: "吹" }, { ch2: "chuī" }, { ko: "입으로 불다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C09.mp3"),
        buttons: [{ ch: "飞" }, { ch2: "fēi" }, { ko: "날다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C10.mp3"),
        buttons: [{ ch: "花籽" }, { ch2: "huāzǐ" }, { ko: "꽃씨" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C11.mp3"),
        buttons: [{ ch: "树叶" }, { ch2: "shùyè" }, { ko: "나뭇잎" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C12.mp3"),
        buttons: [{ ch: "被子" }, { ch2: "bèizi" }, { ko: "이불" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C13.mp3"),
        buttons: [{ ch: "湿" }, { ch2: "shī" }, { ko: "축축하다, <br>습하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C14.mp3"),
        buttons: [{ ch: "照" }, { ch2: "zhào" }, { ko: "비추다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C15.mp3"),
        buttons: [{ ch: "变" }, { ch2: "biàn" }, { ko: "변하다" }],
      },
    ],
    idiom: [
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C16.mp3"),
        buttons: [{ ch: "轻" }, { ch2: "qīng" }, { ko: "가볍다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C17.mp3"),
        buttons: [{ ch: "口哨" }, { ch2: "kǒushào" }, { ko: "휘파람" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C18.mp3"),
        buttons: [{ ch: "打招呼" }, { ch2: "dǎ zhāohu" }, { ko: "인사하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C19.mp3"),
        buttons: [{ ch: "玩" }, { ch2: "wán" }, { ko: "놀다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C20.mp3"),
        buttons: [{ ch: "行人" }, { ch2: "xíngrén" }, { ko: "행인" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C21.mp3"),
        buttons: [{ ch: "脱" }, { ch2: "tuō" }, { ko: "벗다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C22.mp3"),
        buttons: [{ ch: "有意思" }, { ch2: "yǒu yìsi" }, { ko: "재미있다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C23.mp3"),
        buttons: [{ ch: "自信" }, { ch2: "zìxìn" }, { ko: "자신만만하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C24.mp3"),
        buttons: [{ ch: "刮" }, { ch2: "guā" }, { ko: "불다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C25.mp3"),
        buttons: [{ ch: "冷" }, { ch2: "lěng" }, { ko: "춥다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C26.mp3"),
        buttons: [{ ch: "围脖" }, { ch2: "wéibó" }, { ko: "목도리, 머플러" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C27.mp3"),
        buttons: [{ ch: "松开" }, { ch2: "sōngkāi" }, { ko: "풀다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C28.mp3"),
        buttons: [
          { ch: "靠" },
          { ch2: "kào" },
          { ko: "접근하다, <br>다가가다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C29.mp3"),
        buttons: [{ ch: "力量" }, { ch2: "lìliang" }, { ko: "힘" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book3/sounds/C30.mp3"),
        buttons: [{ ch: "肩膀" }, { ch2: "jiānbǎng" }, { ko: "어깨" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/ido/book3/sounds/q4.mp3"),
          img: require("@data/assets/ido/book3/images/q4.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty3",
          sound: require("@data/assets/ido/book3/sounds/C18.mp3"),
          answer: [
            ["打招呼", true],
            ["有意思", false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/ido/book3/sounds/C29.mp3"),
          answer: [
            ["力量", true],
            ["自信", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/ido/book3/pages/front.png"),
        sound: require("@data/assets/ido/book3/sounds/cover.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page02.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page03.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page04.png"),
        sound: require("@data/assets/ido/book3/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page05.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page06.png"),
        sound: require("@data/assets/ido/book3/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page07.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page08.png"),
        sound: require("@data/assets/ido/book3/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page09.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page10.png"),
        sound: require("@data/assets/ido/book3/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page11.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page12.png"),
        sound: require("@data/assets/ido/book3/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page13.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page14.png"),
        sound: require("@data/assets/ido/book3/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page15.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page16.png"),
        sound: require("@data/assets/ido/book3/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page17.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page18.png"),
        sound: require("@data/assets/ido/book3/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page19.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page20.png"),
        sound: require("@data/assets/ido/book3/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page21.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page22.png"),
        sound: require("@data/assets/ido/book3/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page23.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page24.png"),
        sound: require("@data/assets/ido/book3/sounds/page24.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page25.png"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page26.png"),
        sound: require("@data/assets/ido/book3/sounds/page26.mp3"),
      },
      {
        book: require("@data/assets/ido/book3/pages/page27.png"),
      },
    ],
    thumbnail: [
      require("@data/assets/ido/book3/thumbnail/front.png"),
      require("@data/assets/ido/book3/thumbnail/page04.png"),
      require("@data/assets/ido/book3/thumbnail/page05.png"),
      require("@data/assets/ido/book3/thumbnail/page06.png"),
      require("@data/assets/ido/book3/thumbnail/page07.png"),
      require("@data/assets/ido/book3/thumbnail/page08.png"),
      require("@data/assets/ido/book3/thumbnail/page09.png"),
      require("@data/assets/ido/book3/thumbnail/page10.png"),
      require("@data/assets/ido/book3/thumbnail/page11.png"),
      require("@data/assets/ido/book3/thumbnail/page12.png"),
      require("@data/assets/ido/book3/thumbnail/page13.png"),
      require("@data/assets/ido/book3/thumbnail/page14.png"),
      require("@data/assets/ido/book3/thumbnail/page15.png"),
      require("@data/assets/ido/book3/thumbnail/page16.png"),
      require("@data/assets/ido/book3/thumbnail/page17.png"),
      require("@data/assets/ido/book3/thumbnail/page18.png"),
      require("@data/assets/ido/book3/thumbnail/page19.png"),
      require("@data/assets/ido/book3/thumbnail/page20.png"),
      require("@data/assets/ido/book3/thumbnail/page21.png"),
      require("@data/assets/ido/book3/thumbnail/page22.png"),
      require("@data/assets/ido/book3/thumbnail/page23.png"),
      require("@data/assets/ido/book3/thumbnail/page24.png"),
      require("@data/assets/ido/book3/thumbnail/page25.png"),
      require("@data/assets/ido/book3/thumbnail/page26.png"),
      require("@data/assets/ido/book3/thumbnail/page27.png"),
    ],
  },
  //4
  {
    key: "c8-04",
    title: "여우와 두루미",
    grade: "4권",
    cover: require("@data/assets/ido/book4/images/cover.png"),
    background: require("@data/assets/ido/book4/pages/page05.png"),
    mov: {
      ko: "d126def620db0c033d08ce6ca42bc253",
      cn: "4a387fb13f85644dd8c7c577f650d1cf",
      en: "f603d99c396e1f6bd84fc7a966dfc155",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/ido/book4/images/D01.png"),
          sound: require("@data/assets/ido/book4/sounds/D01.mp3"),
          word: "狐狸|húli",
        },
        {
          img: require("@data/assets/ido/book4/images/D02.png"),
          sound: require("@data/assets/ido/book4/sounds/D02.mp3"),
          word: "鹤|hè",
        },
        {
          img: require("@data/assets/ido/book4/images/D03.png"),
          sound: require("@data/assets/ido/book4/sounds/D03.mp3"),
          word: "坏心眼|huàixīnyǎn",
        },
        {
          img: require("@data/assets/ido/book4/images/D04.png"),
          sound: require("@data/assets/ido/book4/sounds/D04.mp3"),
          word: "无聊|wúliáo",
        },
        {
          img: require("@data/assets/ido/book4/images/D05.png"),
          sound: require("@data/assets/ido/book4/sounds/D05.mp3"),
          word: "望|wàng",
        },
        {
          img: require("@data/assets/ido/book4/images/D06.png"),
          sound: require("@data/assets/ido/book4/sounds/D06.mp3"),
          word: "嘴巴|zuǐba",
        },
        {
          img: require("@data/assets/ido/book4/images/D07.png"),
          sound: require("@data/assets/ido/book4/sounds/D07.mp3"),
          word: "羽毛|yǔmáo",
        },
        {
          img: require("@data/assets/ido/book4/images/D08.png"),
          sound: require("@data/assets/ido/book4/sounds/D08.mp3"),
          word: "逗|dòu",
        },
        {
          img: require("@data/assets/ido/book4/images/D09.png"),
          sound: require("@data/assets/ido/book4/sounds/D09.mp3"),
          word: "请|qǐng",
        },
        {
          img: require("@data/assets/ido/book4/images/D10.png"),
          sound: require("@data/assets/ido/book4/sounds/D10.mp3"),
          word: "决定|juédìng",
        },
        {
          img: require("@data/assets/ido/book4/images/D11.png"),
          sound: require("@data/assets/ido/book4/sounds/D11.mp3"),
          word: "蝴蝶结|húdiéjié",
        },
        {
          img: require("@data/assets/ido/book4/images/D12.png"),
          sound: require("@data/assets/ido/book4/sounds/D12.mp3"),
          word: "熨|yùn",
        },
        {
          img: require("@data/assets/ido/book4/images/D13.png"),
          sound: require("@data/assets/ido/book4/sounds/D13.mp3"),
          word: "西装|xīzhuāng",
        },
        {
          img: require("@data/assets/ido/book4/images/D14.png"),
          sound: require("@data/assets/ido/book4/sounds/D14.mp3"),
          word: "帅气|shuàiqì",
        },
        {
          img: require("@data/assets/ido/book4/images/D15.png"),
          sound: require("@data/assets/ido/book4/sounds/D15.mp3"),
          word: "迎接|yíngjiē",
        },
        {
          img: require("@data/assets/ido/book4/images/D16.png"),
          sound: require("@data/assets/ido/book4/sounds/D16.mp3"),
          word: "鱼肉汤|yúròutāng",
        },
        {
          img: require("@data/assets/ido/book4/images/D17.png"),
          sound: require("@data/assets/ido/book4/sounds/D17.mp3"),
          word: "盛|chéng",
        },
        {
          img: require("@data/assets/ido/book4/images/D18.png"),
          sound: require("@data/assets/ido/book4/sounds/D18.mp3"),
          word: "扁平|biǎnpíng",
        },
        {
          img: require("@data/assets/ido/book4/images/D19.png"),
          sound: require("@data/assets/ido/book4/sounds/D19.mp3"),
          word: "啄|zhuó",
        },
        {
          img: require("@data/assets/ido/book4/images/D20.png"),
          sound: require("@data/assets/ido/book4/sounds/D20.mp3"),
          word: "模样|múyàng",
        },
        {
          img: require("@data/assets/ido/book4/images/D21.png"),
          sound: require("@data/assets/ido/book4/sounds/D21.mp3"),
          word: "请帖|qǐngtiě",
        },
        {
          img: require("@data/assets/ido/book4/images/D22.png"),
          sound: require("@data/assets/ido/book4/sounds/D22.mp3"),
          word: "打扮|dǎban",
        },
        {
          img: require("@data/assets/ido/book4/images/D23.png"),
          sound: require("@data/assets/ido/book4/sounds/D23.mp3"),
          word: "闻|wén",
        },
        {
          img: require("@data/assets/ido/book4/images/D24.png"),
          sound: require("@data/assets/ido/book4/sounds/D24.mp3"),
          word: "口水|kǒushuǐ",
        },
        {
          img: require("@data/assets/ido/book4/images/D25.png"),
          sound: require("@data/assets/ido/book4/sounds/D25.mp3"),
          word: "敲|qiāo",
        },
        {
          img: require("@data/assets/ido/book4/images/D26.png"),
          sound: require("@data/assets/ido/book4/sounds/D26.mp3"),
          word: "餐桌|cānzhuō",
        },
        {
          img: require("@data/assets/ido/book4/images/D27.png"),
          sound: require("@data/assets/ido/book4/sounds/D27.mp3"),
          word: "瓶子|píngzi",
        },
        {
          img: require("@data/assets/ido/book4/images/D28.png"),
          sound: require("@data/assets/ido/book4/sounds/D28.mp3"),
          word: "费劲儿|fèijìnr",
        },
        {
          img: require("@data/assets/ido/book4/images/D29.png"),
          sound: require("@data/assets/ido/book4/sounds/D29.mp3"),
          word: "对待|duìdài",
        },
        {
          img: require("@data/assets/ido/book4/images/D30.png"),
          sound: require("@data/assets/ido/book4/sounds/D30.mp3"),
          word: "停|tíng",
        },
      ],
      resources2: [
        {
          img: require("@data/assets/ido/book4/images/q1.png"),
          sound: require("@data/assets/ido/book4/sounds/q1.mp3"),
          word: "狐狸和鹤高兴地问了好。|",
        },
        {
          img: require("@data/assets/ido/book4/images/q2.png"),
          sound: require("@data/assets/ido/book4/sounds/q2.mp3"),
          word: "“哦， 真帅啊！”鹤看着镜子里自己的样子说。|",
        },
        {
          img: require("@data/assets/ido/book4/images/q3.png"),
          sound: require("@data/assets/ido/book4/sounds/q3.mp3"),
          word: "狐狸高兴地迎接鹤。|",
        },
        {
          img: require("@data/assets/ido/book4/images/q4.png"),
          sound: require("@data/assets/ido/book4/sounds/q4.mp3"),
          word: "鹤用长长的嘴“笃笃”地啄着鱼肉汤，可就是喝不到嘴里。|",
        },
        {
          img: require("@data/assets/ido/book4/images/q5.png"),
          sound: require("@data/assets/ido/book4/sounds/q5.mp3"),
          word: "刚一走到鹤家，就能闻见香喷喷的肉汤味。|",
        },
        {
          img: require("@data/assets/ido/book4/images/q6.png"),
          sound: require("@data/assets/ido/book4/sounds/q6.mp3"),
          word: "狐狸费劲儿地想把嘴伸进细细长长的瓶子里。|",
        },
        {
          img: require("@data/assets/ido/book4/images/q7.png"),
          sound: require("@data/assets/ido/book4/sounds/q7.mp3"),
          word: "鹤用长长的嘴“笃笃”地啄光了瓶子里的肉汤。|",
        },
      ],
    },
    word: [
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D01.mp3"),
        buttons: [{ ch: "狐狸" }, { ch2: "húli" }, { ko: "여우" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D02.mp3"),
        buttons: [{ ch: "鹤" }, { ch2: "hè" }, { ko: "학" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D03.mp3"),
        buttons: [{ ch: "坏心眼" }, { ch2: "huàixīnyǎn" }, { ko: "나쁜 마음" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D04.mp3"),
        buttons: [
          { ch: "无聊" },
          { ch2: "wúliáo" },
          { ko: "무료하다, <br>따분하다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D05.mp3"),
        buttons: [{ ch: "望" }, { ch2: "wàng" }, { ko: "바라보다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D06.mp3"),
        buttons: [{ ch: "嘴巴" }, { ch2: "zuǐba" }, { ko: "입, 주둥이" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D07.mp3"),
        buttons: [{ ch: "羽毛" }, { ch2: "yǔmáo" }, { ko: "깃털" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D08.mp3"),
        buttons: [{ ch: "逗" }, { ch2: "dòu" }, { ko: "놀리다, 골리다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D09.mp3"),
        buttons: [
          { ch: "请" },
          { ch2: "qǐng" },
          { ko: "초청하다, <br>초빙하다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D10.mp3"),
        buttons: [{ ch: "决定" }, { ch2: "juédìng" }, { ko: "결정하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D11.mp3"),
        buttons: [{ ch: "蝴蝶结" }, { ch2: "húdiéjié" }, { ko: "나비넥타이" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D12.mp3"),
        buttons: [{ ch: "熨" }, { ch2: "yùn" }, { ko: "다림질하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D13.mp3"),
        buttons: [{ ch: "西装" }, { ch2: "xīzhuāng" }, { ko: "양복" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D14.mp3"),
        buttons: [
          { ch: "帅气" },
          { ch2: "shuàiqì" },
          { ko: "멋지다, <br>잘생기다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D15.mp3"),
        buttons: [
          { ch: "迎接" },
          { ch2: "yíngjiē" },
          { ko: "영접하다, <br>마중하다" },
        ],
      },
    ],
    idiom: [
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D16.mp3"),
        buttons: [
          { ch: "鱼肉汤" },
          { ch2: "yúròutāng" },
          { ko: "물고기 수프, <br>생선국" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D17.mp3"),
        buttons: [{ ch: "盛" }, { ch2: "chéng" }, { ko: "물건을 담다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D18.mp3"),
        buttons: [{ ch: "扁平" }, { ch2: "biǎnpíng" }, { ko: "평편하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D19.mp3"),
        buttons: [
          { ch: "啄" },
          { ch2: "zhuó" },
          { ko: "부리로 쪼다, <br>쪼아 먹다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D20.mp3"),
        buttons: [{ ch: "模样" }, { ch2: "múyàng" }, { ko: "모양, 모습" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D21.mp3"),
        buttons: [{ ch: "请帖" }, { ch2: "qǐngtiě" }, { ko: "청첩장" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D22.mp3"),
        buttons: [{ ch: "打扮" }, { ch2: "dǎban" }, { ko: "화장을 하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D23.mp3"),
        buttons: [{ ch: "闻" }, { ch2: "wén" }, { ko: "냄새를 맡다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D24.mp3"),
        buttons: [{ ch: "口水" }, { ch2: "kǒushuǐ" }, { ko: "침" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D25.mp3"),
        buttons: [{ ch: "敲" }, { ch2: "qiāo" }, { ko: "치다, 두드리다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D26.mp3"),
        buttons: [{ ch: "餐桌" }, { ch2: "cānzhuō" }, { ko: "식탁" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D27.mp3"),
        buttons: [{ ch: "瓶子" }, { ch2: "píngzi" }, { ko: "병" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D28.mp3"),
        buttons: [{ ch: "费劲儿" }, { ch2: "fèijìnr" }, { ko: "기운을 쓰다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D29.mp3"),
        buttons: [
          { ch: "对待" },
          { ch2: "duìdài" },
          { ko: "다루다, <br>대응하다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book4/sounds/D30.mp3"),
        buttons: [{ ch: "停" }, { ch2: "tíng" }, { ko: "멈추다" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/ido/book4/sounds/q4.mp3"),
          img: require("@data/assets/ido/book4/images/q2.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty3",
          sound: require("@data/assets/ido/book4/sounds/D03.mp3"),
          answer: [
            ["坏心眼", true],
            ["费劲儿", false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/ido/book4/sounds/D13.mp3"),
          answer: [
            ["西装", true],
            ["羽毛", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/ido/book4/pages/front.png"),
        sound: require("@data/assets/ido/book4/sounds/cover.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page02.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page03.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page04.png"),
        sound: require("@data/assets/ido/book4/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page05.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page06.png"),
        sound: require("@data/assets/ido/book4/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page07.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page08.png"),
        sound: require("@data/assets/ido/book4/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page09.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page10.png"),
        sound: require("@data/assets/ido/book4/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page11.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page12.png"),
        sound: require("@data/assets/ido/book4/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page13.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page14.png"),
        sound: require("@data/assets/ido/book4/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page15.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page16.png"),
        sound: require("@data/assets/ido/book4/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page17.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page18.png"),
        sound: require("@data/assets/ido/book4/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page19.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page20.png"),
        sound: require("@data/assets/ido/book4/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page21.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page22.png"),
        sound: require("@data/assets/ido/book4/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page23.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page24.png"),
        sound: require("@data/assets/ido/book4/sounds/page24.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page25.png"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page26.png"),
        sound: require("@data/assets/ido/book4/sounds/page26.mp3"),
      },
      {
        book: require("@data/assets/ido/book4/pages/page27.png"),
      },
    ],
    thumbnail: [
      require("@data/assets/ido/book4/thumbnail/front.png"),
      require("@data/assets/ido/book4/thumbnail/page04.png"),
      require("@data/assets/ido/book4/thumbnail/page05.png"),
      require("@data/assets/ido/book4/thumbnail/page06.png"),
      require("@data/assets/ido/book4/thumbnail/page07.png"),
      require("@data/assets/ido/book4/thumbnail/page08.png"),
      require("@data/assets/ido/book4/thumbnail/page09.png"),
      require("@data/assets/ido/book4/thumbnail/page10.png"),
      require("@data/assets/ido/book4/thumbnail/page11.png"),
      require("@data/assets/ido/book4/thumbnail/page12.png"),
      require("@data/assets/ido/book4/thumbnail/page13.png"),
      require("@data/assets/ido/book4/thumbnail/page14.png"),
      require("@data/assets/ido/book4/thumbnail/page15.png"),
      require("@data/assets/ido/book4/thumbnail/page16.png"),
      require("@data/assets/ido/book4/thumbnail/page17.png"),
      require("@data/assets/ido/book4/thumbnail/page18.png"),
      require("@data/assets/ido/book4/thumbnail/page19.png"),
      require("@data/assets/ido/book4/thumbnail/page20.png"),
      require("@data/assets/ido/book4/thumbnail/page21.png"),
      require("@data/assets/ido/book4/thumbnail/page22.png"),
      require("@data/assets/ido/book4/thumbnail/page23.png"),
      require("@data/assets/ido/book4/thumbnail/page24.png"),
      require("@data/assets/ido/book4/thumbnail/page25.png"),
      require("@data/assets/ido/book4/thumbnail/page26.png"),
      require("@data/assets/ido/book4/thumbnail/page27.png"),
    ],
  },
  //5
  {
    key: "c8-05",
    title: "인어공주",
    grade: "5권",
    cover: require("@data/assets/ido/book5/images/cover.png"),
    background: require("@data/assets/ido/book5/pages/page05.png"),
    mov: {
      ko: "71771c9fc68d0d42eff5518bb410f9f3",
      cn: "7856b7146ca2ee33f9f94072bf3d66ac",
      en: "59385140639b1a71bdf26c1919320a64",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/ido/book5/images/E01.png"),
          sound: require("@data/assets/ido/book5/sounds/E01.mp3"),
          word: "人鱼|rényú",
        },
        {
          img: require("@data/assets/ido/book5/images/E02.png"),
          sound: require("@data/assets/ido/book5/sounds/E02.mp3"),
          word: "公主|gōngzhǔ",
        },
        {
          img: require("@data/assets/ido/book5/images/E03.png"),
          sound: require("@data/assets/ido/book5/sounds/E03.mp3"),
          word: "怀|huái",
        },
        {
          img: require("@data/assets/ido/book5/images/E04.png"),
          sound: require("@data/assets/ido/book5/sounds/E04.mp3"),
          word: "跳动|tiàodòng",
        },
        {
          img: require("@data/assets/ido/book5/images/E05.png"),
          sound: require("@data/assets/ido/book5/sounds/E05.mp3"),
          word: "远处|yuǎn chù",
        },
        {
          img: require("@data/assets/ido/book5/images/E06.png"),
          sound: require("@data/assets/ido/book5/sounds/E06.mp3"),
          word: "站|zhàn",
        },
        {
          img: require("@data/assets/ido/book5/images/E07.png"),
          sound: require("@data/assets/ido/book5/sounds/E07.mp3"),
          word: "一见钟情|yí jiàn zhōng qíng",
        },
        {
          img: require("@data/assets/ido/book5/images/E08.png"),
          sound: require("@data/assets/ido/book5/sounds/E08.mp3"),
          word: "暗|àn",
        },
        {
          img: require("@data/assets/ido/book5/images/E09.png"),
          sound: require("@data/assets/ido/book5/sounds/E09.mp3"),
          word: "波涛|bōtāo",
        },
        {
          img: require("@data/assets/ido/book5/images/E10.png"),
          sound: require("@data/assets/ido/book5/sounds/E10.mp3"),
          word: "乘|chéng",
        },
        {
          img: require("@data/assets/ido/book5/images/E11.png"),
          sound: require("@data/assets/ido/book5/sounds/E11.mp3"),
          word: "打翻|dǎfān",
        },
        {
          img: require("@data/assets/ido/book5/images/E12.png"),
          sound: require("@data/assets/ido/book5/sounds/E12.mp3"),
          word: "掉|diào",
        },
        {
          img: require("@data/assets/ido/book5/images/E13.png"),
          sound: require("@data/assets/ido/book5/sounds/E13.mp3"),
          word: "拉|lā",
        },
        {
          img: require("@data/assets/ido/book5/images/E14.png"),
          sound: require("@data/assets/ido/book5/sounds/E14.mp3"),
          word: "照顾|zhào gù",
        },
        {
          img: require("@data/assets/ido/book5/images/E15.png"),
          sound: require("@data/assets/ido/book5/sounds/E15.mp3"),
          word: "靠近|kàojìn",
        },
        {
          img: require("@data/assets/ido/book5/images/E16.png"),
          sound: require("@data/assets/ido/book5/sounds/E16.mp3"),
          word: "苏醒|sūxǐng",
        },
        {
          img: require("@data/assets/ido/book5/images/E17.png"),
          sound: require("@data/assets/ido/book5/sounds/E17.mp3"),
          word: "伤心|shāng xīn",
        },
        {
          img: require("@data/assets/ido/book5/images/E18.png"),
          sound: require("@data/assets/ido/book5/sounds/E18.mp3"),
          word: "深处|shēnchù",
        },
        {
          img: require("@data/assets/ido/book5/images/E19.png"),
          sound: require("@data/assets/ido/book5/sounds/E19.mp3"),
          word: "想念|xiǎngniàn",
        },
        {
          img: require("@data/assets/ido/book5/images/E20.png"),
          sound: require("@data/assets/ido/book5/sounds/E20.mp3"),
          word: "魔女|mónǚ",
        },
        {
          img: require("@data/assets/ido/book5/images/E21.png"),
          sound: require("@data/assets/ido/book5/sounds/E21.mp3"),
          word: "腿|tuǐ",
        },
        {
          img: require("@data/assets/ido/book5/images/E22.png"),
          sound: require("@data/assets/ido/book5/sounds/E22.mp3"),
          word: "泡沫|pàomò",
        },
        {
          img: require("@data/assets/ido/book5/images/E23.png"),
          sound: require("@data/assets/ido/book5/sounds/E23.mp3"),
          word: "浑身|húnshēn",
        },
        {
          img: require("@data/assets/ido/book5/images/E24.png"),
          sound: require("@data/assets/ido/book5/sounds/E24.mp3"),
          word: "晕倒|yūndǎo",
        },
        {
          img: require("@data/assets/ido/book5/images/E25.png"),
          sound: require("@data/assets/ido/book5/sounds/E25.mp3"),
          word: "宫殿|gōngdiàn",
        },
        {
          img: require("@data/assets/ido/book5/images/E26.png"),
          sound: require("@data/assets/ido/book5/sounds/E26.mp3"),
          word: "幸福|xìngfú",
        },
        {
          img: require("@data/assets/ido/book5/images/E27.png"),
          sound: require("@data/assets/ido/book5/sounds/E27.mp3"),
          word: "消失|xiāoshī",
        },
        {
          img: require("@data/assets/ido/book5/images/E28.png"),
          sound: require("@data/assets/ido/book5/sounds/E28.mp3"),
          word: "换|huàn",
        },
        {
          img: require("@data/assets/ido/book5/images/E29.png"),
          sound: require("@data/assets/ido/book5/sounds/E29.mp3"),
          word: "原谅|yuánliàng",
        },
        {
          img: require("@data/assets/ido/book5/images/E30.png"),
          sound: require("@data/assets/ido/book5/sounds/E30.mp3"),
          word: "精灵|jīnglíng",
        },
      ],
      resources2: [
        {
          img: require("@data/assets/ido/book5/images/q1.png"),
          sound: require("@data/assets/ido/book5/sounds/q1.mp3"),
          word: "远处飘飘悠悠地靠过来一条船。|",
        },
        {
          img: require("@data/assets/ido/book5/images/q2.png"),
          sound: require("@data/assets/ido/book5/sounds/q2.mp3"),
          word: "船上坐着一位英俊的王子。|",
        },
        {
          img: require("@data/assets/ido/book5/images/q3.png"),
          sound: require("@data/assets/ido/book5/sounds/q3.mp3"),
          word: "人鱼公主用心地照顾王子。|",
        },
        {
          img: require("@data/assets/ido/book5/images/q4.png"),
          sound: require("@data/assets/ido/book5/sounds/q4.mp3"),
          word: "王子非常疼爱人鱼公主， 所以不管去哪儿都会带着她。|",
        },
        {
          img: require("@data/assets/ido/book5/images/q5.png"),
          sound: require("@data/assets/ido/book5/sounds/q5.mp3"),
          word: "人鱼公主流着眼泪，向外面跑去。|",
        },
      ],
    },
    word: [
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E01.mp3"),
        buttons: [{ ch: "人鱼" }, { ch2: "rényú" }, { ko: "인어" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E02.mp3"),
        buttons: [{ ch: "公主" }, { ch2: "gōngzhǔ" }, { ko: "공주" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E03.mp3"),
        buttons: [{ ch: "怀" }, { ch2: "huái" }, { ko: "품다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E04.mp3"),
        buttons: [{ ch: "跳动" }, { ch2: "tiàodòng" }, { ko: "두근거리다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E05.mp3"),
        buttons: [{ ch: "远处" }, { ch2: "yuǎn chù" }, { ko: "먼 곳, 먼 데" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E06.mp3"),
        buttons: [{ ch: "站" }, { ch2: "zhàn" }, { ko: "서다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E07.mp3"),
        buttons: [
          { ch: "一见钟情" },
          { ch2: "yí jiàn zhōng qíng" },
          { ko: "한눈에 반하다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E08.mp3"),
        buttons: [{ ch: "暗" }, { ch2: "àn" }, { ko: "어둡다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E09.mp3"),
        buttons: [{ ch: "波涛" }, { ch2: "bōtāo" }, { ko: "파도" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E10.mp3"),
        buttons: [{ ch: "乘" }, { ch2: "chéng" }, { ko: "타다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E11.mp3"),
        buttons: [
          { ch: "打翻" },
          { ch2: "dǎfān" },
          { ko: "뒤집히다, <br>전복되다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E12.mp3"),
        buttons: [{ ch: "掉" }, { ch2: "diào" }, { ko: "떨어지다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E13.mp3"),
        buttons: [{ ch: "拉" }, { ch2: "lā" }, { ko: "끌다, 당기다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E14.mp3"),
        buttons: [
          { ch: "照顾" },
          { ch2: "zhào gù" },
          { ko: "보살피다, <br>돌보다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E15.mp3"),
        buttons: [
          { ch: "靠近" },
          { ch2: "kàojìn" },
          { ko: "가까이 가다, <br>다가가다" },
        ],
      },
    ],
    idiom: [
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E16.mp3"),
        buttons: [
          { ch: "苏醒" },
          { ch2: "sūxǐng" },
          { ko: "의식을 <br>회복하다, <br>정신차리다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E17.mp3"),
        buttons: [
          { ch: "伤心" },
          { ch2: "shāng xīn" },
          { ko: "상심하다, <br>마음 아파하다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E18.mp3"),
        buttons: [{ ch: "深处" }, { ch2: "shēnchù" }, { ko: "깊숙한 곳" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E19.mp3"),
        buttons: [{ ch: "想念" }, { ch2: "xiǎngniàn" }, { ko: "그리워하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E20.mp3"),
        buttons: [{ ch: "魔女" }, { ch2: "mónǚ" }, { ko: "마녀" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E21.mp3"),
        buttons: [{ ch: "腿" }, { ch2: "tuǐ" }, { ko: "다리" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E22.mp3"),
        buttons: [{ ch: "泡沫" }, { ch2: "pàomò" }, { ko: "거품" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E23.mp3"),
        buttons: [{ ch: "浑身" }, { ch2: "húnshēn" }, { ko: "전신" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E24.mp3"),
        buttons: [
          { ch: "晕倒" },
          { ch2: "yūndǎo" },
          { ko: "기절하여 <br>쓰러지다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E25.mp3"),
        buttons: [{ ch: "宫殿" }, { ch2: "gōngdiàn" }, { ko: "궁전" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E26.mp3"),
        buttons: [{ ch: "幸福" }, { ch2: "xìngfú" }, { ko: "행복하다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E27.mp3"),
        buttons: [{ ch: "消失" }, { ch2: "xiāoshī" }, { ko: "감추다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E28.mp3"),
        buttons: [{ ch: "换" }, { ch2: "huàn" }, { ko: "바꾸다" }],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E29.mp3"),
        buttons: [
          { ch: "原谅" },
          { ch2: "yuánliàng" },
          { ko: "양해하다, <br>이해하다" },
        ],
      },
      {
        img: "null",
        sound: require("@data/assets/ido/book5/sounds/E30.mp3"),
        buttons: [{ ch: "精灵" }, { ch2: "jīnglíng" }, { ko: "요정" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/ido/book5/sounds/q3.mp3"),
          img: require("@data/assets/ido/book5/images/q3.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty3",
          sound: require("@data/assets/ido/book5/sounds/E14.mp3"),
          answer: [
            ["原谅", false],
            ["照顾", true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/ido/book5/sounds/E26.mp3"),
          answer: [
            ["幸福", true],
            ["消失", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/ido/book5/pages/front.png"),
        sound: require("@data/assets/ido/book5/sounds/cover.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page02.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page03.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page04.png"),
        sound: require("@data/assets/ido/book5/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page05.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page06.png"),
        sound: require("@data/assets/ido/book5/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page07.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page08.png"),
        sound: require("@data/assets/ido/book5/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page09.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page10.png"),
        sound: require("@data/assets/ido/book5/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page11.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page12.png"),
        sound: require("@data/assets/ido/book5/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page13.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page14.png"),
        sound: require("@data/assets/ido/book5/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page15.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page16.png"),
        sound: require("@data/assets/ido/book5/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page17.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page18.png"),
        sound: require("@data/assets/ido/book5/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page19.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page20.png"),
        sound: require("@data/assets/ido/book5/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page21.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page22.png"),
        sound: require("@data/assets/ido/book5/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page23.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page24.png"),
        sound: require("@data/assets/ido/book5/sounds/page24.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page25.png"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page26.png"),
        sound: require("@data/assets/ido/book5/sounds/page26.mp3"),
      },
      {
        book: require("@data/assets/ido/book5/pages/page27.png"),
      },
    ],
    thumbnail: [
      require("@data/assets/ido/book5/thumbnail/front.png"),
      require("@data/assets/ido/book5/thumbnail/page04.png"),
      require("@data/assets/ido/book5/thumbnail/page05.png"),
      require("@data/assets/ido/book5/thumbnail/page06.png"),
      require("@data/assets/ido/book5/thumbnail/page07.png"),
      require("@data/assets/ido/book5/thumbnail/page08.png"),
      require("@data/assets/ido/book5/thumbnail/page09.png"),
      require("@data/assets/ido/book5/thumbnail/page10.png"),
      require("@data/assets/ido/book5/thumbnail/page11.png"),
      require("@data/assets/ido/book5/thumbnail/page12.png"),
      require("@data/assets/ido/book5/thumbnail/page13.png"),
      require("@data/assets/ido/book5/thumbnail/page14.png"),
      require("@data/assets/ido/book5/thumbnail/page15.png"),
      require("@data/assets/ido/book5/thumbnail/page16.png"),
      require("@data/assets/ido/book5/thumbnail/page17.png"),
      require("@data/assets/ido/book5/thumbnail/page18.png"),
      require("@data/assets/ido/book5/thumbnail/page19.png"),
      require("@data/assets/ido/book5/thumbnail/page20.png"),
      require("@data/assets/ido/book5/thumbnail/page21.png"),
      require("@data/assets/ido/book5/thumbnail/page22.png"),
      require("@data/assets/ido/book5/thumbnail/page23.png"),
      require("@data/assets/ido/book5/thumbnail/page24.png"),
      require("@data/assets/ido/book5/thumbnail/page25.png"),
      require("@data/assets/ido/book5/thumbnail/page26.png"),
      require("@data/assets/ido/book5/thumbnail/page27.png"),
    ],
  },
];
